import { render, staticRenderFns } from "./ViewPurchasedMerchantRewardsDetails.vue?vue&type=template&id=03d857dd&"
import script from "./ViewPurchasedMerchantRewardsDetails.vue?vue&type=script&lang=js&"
export * from "./ViewPurchasedMerchantRewardsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports